import { QueryClient } from "@tanstack/react-query";

import { isNonRetryableClientError } from "./is-non-retryable-client-error";

const MAX_RETRY_COUNT = 3;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      retry: (failureCount, error) => {
        if (isNonRetryableClientError(error)) {
          return false;
        }
        return failureCount < MAX_RETRY_COUNT;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
